import React, { useEffect, useState } from "react";
import Images from "../../../constant/Images";
import { STORAGE_PATH, bundlesInput } from "../../../constant/string";
import InputComponent from "../../inputComponent/InputComponent";
import { useFormik } from "formik";
import * as Yup from "yup";
import CheckBox from "../../checkbox/CheckBox";
import services from "../../../services/services";
import { useAppDispatch } from "../../../store/app/store";
import { getallBundlesThank } from "../../../store/features/getBundlesSlice";
import { toast } from "react-toastify";
import EditInputComponent from "../../inputComponent/EditInputComponent";
import { useSelector } from "react-redux";
import EmailInputComponent from "../../inputComponent/EmailInputComponent";
import SelectComponent from "../../selectComponent/SelectComponent";
import RichTextEditor from "../../RichTextEditor";
import LanguageInputComponentText from "../../inputComponent/LanguageInputComponentText";

type NewTemplateObj = {
  language: string;
  isRendering: boolean;
  text: string;
  error: any;
};
const EditBundule = ({ data }: any) => {
  const { Tours } = useSelector((state: any) => state.tours);
  const dispatch: any = useAppDispatch();
  const [showModal, setShowModal] = React.useState(false);
  const [File, setFile] = useState<any>({});
  const [deletedtoursIds, setDeletedtoursIds] = useState<any>([]);
  const [bundleTours, setBundleTours] = useState<any>(
    // data?.bundelDetails?.map((elm: any) => elm?.tourBundelsDetails)
    []
  );
  const [tourInBundle, setTourInBundle] = useState<any>({});
  const [descriptionLanguageData, setDescriptionLanguageData] = useState<any>(() => {
    // Parse existing description — could be JSON array or plain string
    try {
      const parsed = typeof data?.description === 'string' ? JSON.parse(data?.description) : data?.description;
      return Array.isArray(parsed) ? parsed : [{ language: 'en', text: data?.description || '' }];
    } catch {
      return [{ language: 'en', text: data?.description || '' }];
    }
  });
  const [nameLanguageData, setNameLanguageData] = useState<any>(() => {
    try {
      const parsed = typeof data?.name === 'string' ? JSON.parse(data?.name) : data?.name;
      return Array.isArray(parsed) ? parsed : [{ language: 'en', text: data?.name || '' }];
    } catch {
      return [{ language: 'en', text: data?.name || '' }];
    }
  });
  const [choosenLanguage, setChoosenLanguage] = useState<string[]>(["en"]);

  const setTemplateData = (
    updater:
      | NewTemplateObj[]
      | ((prevData: NewTemplateObj[]) => NewTemplateObj[])
  ) => {
    if (typeof updater === "function") {
      let value = updater(formik.values.bundleEmailTemplate);
      formik.setFieldValue("bundleEmailTemplate", value);
    } else {
      formik.setFieldValue("bundleEmailTemplate", updater);
    }
  };

  useEffect(() => {
    if (showModal) {
      const tours: any = {};
      data?.bundelDetails?.forEach((elm: any) => {
        tours[elm?.tourBundelsDetails?.id] = true;
      });

      setTourInBundle(tours);
      const toursData = data?.bundelDetails?.map((elm: any) => ({
        originTourId: elm?.tourBundelsDetails?.id,
        ...elm,
      }));
      setBundleTours(toursData);
    }
  }, [showModal]);

  const handleAddBunleTours = (tour: any) => {
    setBundleTours((prev: any) => [
      ...prev,
      { originTourId: tour?.id, ...tour },
    ]);
    setTourInBundle((prev: any) => ({ ...prev, [tour?.id]: true }));
  };
  const handleFilterBundleTours = (tour: any) => {
    const originId = tour?.originTourId ?? tour?.id;
    if (tour?.bundelId) {
      setDeletedtoursIds((prev: any) => [...prev, tour]);
    }
    setBundleTours((prev: any) =>
      prev.filter(
        (item: any) => (item?.originTourId ?? item?.id) !== originId
      )
    );
    setTourInBundle((prev: any) => {
      const next = { ...prev };
      delete next[originId];
      return next;
    });
  };

  const intializeTemplate = () => {
    const temp = data?.bundleEmailTemplate
      ? JSON.parse(data.bundleEmailTemplate)
      : [];
    const newTemplate = temp.map((item: any) => ({
      ...item,
      isRendering: false,
      error: "",
    }));
    return newTemplate;
  };

  const validateAllTemplate = (templates: NewTemplateObj[]) => {
    return templates.map((item) => {
      const doc = new DOMParser().parseFromString(item.text, "text/html");
      const isError = doc.querySelector("parsererror");
      return isError
        ? { ...item, text: "" }
        : { ...item, text: doc.documentElement.outerHTML };
    });
  };

  const formik = useFormik({
    initialValues: {
      name: data?.name,
      productId: data?.productId,
      imageUrl: data?.imageUrl,
      description: data?.description,
      retailPrice: data?.retailPrice,
      sellingPrice: data?.sellingPrice,
      bokunId: data?.bokunId,
      published: data?.published ?? 1,
      bundleEmailTemplate: intializeTemplate(),
    },
    validationSchema: Yup.object({
      name: Yup.string().trim().required("This field is required"),
      productId: Yup.string()
        .trim()
        .required("This field is required")
        .test("no-spaces", "Name cannot contain spaces", (value: any) => {
          return value && !/\s/.test(value);
        }),
      bundleEmailTemplate: Yup.array().notRequired(),
      // Required: see AddBundles — a blank/0 or mismatched Bokun Id makes every
      // website code for this bundle fail in the app with "Code not found".
      bokunId: Yup.number()
        .typeError("Bokun Id must be a number")
        .integer("Bokun Id must be a whole number")
        .positive("Bokun Id is required and must be greater than 0")
        .required(
          "Bokun Id is required — it must match this bundle's Bokun ID on the website admin, or website bundle codes will not work in the app"
        ),
      description: Yup.string().trim().required("This field is required"),
      sellingPrice: Yup.number()
        .typeError("Please enter a number value only")
        .nullable()
        .transform((value, originalValue) => {
          console.log("originalValue: ", originalValue);
          return originalValue.trim() === "" ? null : parseFloat(originalValue);
        })
        .lessThan(
          Yup.ref("retailPrice"),
          "Selling price is less than or equal to retail price"
        ),
      retailPrice: Yup.number()
        .notOneOf([0], "Zero and negative values not accepted")
        .required("This field is  required"),
      imageUrl: Yup.string().trim().required("This Field is  Required"),
      published: Yup.number().oneOf([0, 1]).notRequired()
    }),
    onSubmit: (values) => {
      const validatedTemplates = validateAllTemplate(
        values.bundleEmailTemplate
      );

      const templateSave = validatedTemplates.map((item: NewTemplateObj) => ({
        text: item.text,
        language: item.language,
      }));

      if (bundleTours?.length) {
        handleAddTour({
          ...values,
          bokunId: Number(values.bokunId),
          name: JSON.stringify(nameLanguageData),
          description: JSON.stringify(descriptionLanguageData),
          bundleEmailTemplate: JSON.stringify(templateSave),
          imageUrl: File?.imageUrl?.replace(`${STORAGE_PATH}/imageUpload/`, ""),
        });
      } else {
        toast.error("Please add Tours");
      }
    },
    enableReinitialize: true,
  });

  const deleteImageUri = async () => {
    setFile({
      ...File,
      imageUrl: "",
    });
    formik.setFieldValue("imageUrl", "");
  };

  const handleAddTour = async (payload: any) => {
    const finalPayoad = {
      ...payload,
      bundelsId: data?.id,
      deletedtoursIds: deletedtoursIds.map((item: any) => item.id),
      bundlesTours: bundleTours?.map((item: any) => {
        const payload = {
          placeId: item?.placeId,
          tourId: item?.id,
          id: item?.bundleInTourId,
        };
        if (item?.bundleInTourId === null) {
          payload["id"] = null;
        }
        return payload;
      }),
    };

    try {
      const res: any = await services.updateBundles(finalPayoad);
      if (res?.status) {
        toast.success("Bundles Updated Successfully");
        dispatch(getallBundlesThank());
        setShowModal(false);
      } else {
        toast.dismiss();
        toast.error("someThing Went Wrong");
      }
    } catch (error) {
      console.error("something went wrong while updating bundle",error)
      toast.dismiss();
      toast.error("someThing Went Wrong");
    }
  };

  const handleChangeOnFile = async (e: any) => {
    try {
      if (e.target.accept === "image/*") {
        const file = e.target.files[0];
        if (file) {
          const res = await services.uploadImage(file);

          if (res?.data?.data?.url[0]?.path) {
            const uploadedFilename = res?.data?.data?.url[0]?.path;
            setFile((prevFile:{}) => ({
              ...prevFile,
              [e.target.name]: uploadedFilename,
            }));

            formik.setFieldValue("imageUrl", uploadedFilename);
            formik.setFieldError("imageUrl", "");
          } else {
            formik.setFieldValue("imageUrl", ""); // Set the field value to an empty string
            formik.setFieldError("imageUrl", "Please select a correct image"); // Set an error message
          }
        } else {
          formik.setFieldValue("imageUrl", ""); // Clear the field value
          formik.setFieldError("imageUrl", "Please select a file"); // Set an error message
        }
      }
    } catch (error) {
      toast.error("Something went wrong while uploading the image");
      console.log("error", error);
    }
  };
  
  useEffect(() => {
    formik?.handleReset(formik.values);
    if (showModal) {
      (formik as any).values = {
        name: data?.name,
        imageUrl: data?.imageUrl,
        description: data?.description,
        retailPrice: data?.retailPrice,
        sellingPrice: data?.sellingPrice,
        productId: data?.productId,
        bokunId: data?.bokunId,
        bokunId2: data?.bokunId2,
        bundleEmailTemplate: intializeTemplate(),
      };
    }
  }, [showModal]);

  return (
    <>
      <img
        src={Images.edit}
        alt="edit"
        onClick={() => setShowModal(true)}
        className="ml-2"
      />
      {showModal ? (
        <>
          <div className="justify-center items-center flex  fixed inset-0 z-50 outline-none">
            <div className="relative w-[900px] h-[600px] bg-white my-6 rounded overflow-y-auto">
              {/*content*/}

              {/*header*/}

              <div className="flex justify-between text-xl font-semibold bg-lightaqua w-[100%] h-[70px] items-center rounded">
                <div></div>
                <h3 className="font-sans font-bold">Add Bundles</h3>
                <div className="bg-aquadark w-[70px] h-[70px] rounded-xl flex justify-center ">
                  <button className="p-1" onClick={() => setShowModal(false)}>
                    <img
                      className=" text-black h-7 w-7 outline-none focus:outline-none "
                      src={Images.closecircle}
                      alt=""
                    ></img>
                  </button>
                </div>
              </div>
              {/*body*/}
              <form onSubmit={formik.handleSubmit} className="px-12 py-9">
                <div className="">
                  {bundlesInput.map((elm: any) =>
                    elm?.key === "option" ? (
                      <SelectComponent
                        id={elm?.name}
                        handlechange={formik.handleChange}
                        value={(formik as any)?.values[elm.name]}
                        name={elm?.name}
                        label={elm?.label}
                        placeholder={elm?.placeHolder}
                        type={elm?.type}
                        error={(formik as any).errors[elm.name]}
                        touched={(formik as any).touched[elm.name]}
                        option={elm?.option}
                      />
                    ) : elm?.type == "file" ? (
                      <EditInputComponent
                        key={elm?.name}
                        id={elm?.name}
                        handlechange={handleChangeOnFile}
                        deleteImageUri={deleteImageUri}
                        accept={elm?.accept}
                        value={(formik as any)?.values?.[elm?.name]}
                        name={elm?.name}
                        label={elm?.label}
                        placeholder={elm?.placeHolder}
                        type={elm?.type}
                        error={(formik as any).errors[elm.name]}
                        touched={(formik as any).touched[elm.name]}
                      />
                    ) : elm?.type === "richtext" ? (
                      <RichTextEditor
                        key={elm?.name}
                        label={elm?.label}
                        value={descriptionLanguageData}
                        handlechange={(langData: any) => {
                          setDescriptionLanguageData(langData);
                          formik.setFieldValue("description", JSON.stringify(langData));
                        }}
                        placeholder={elm?.placeHolder}
                        discription={data?.description}
                        choosenLanguage={choosenLanguage}
                      />
                    ) : elm?.type === "email" ? (
                      <>
                        <EmailInputComponent
                          key={elm?.name}
                          templateData={formik.values.bundleEmailTemplate}
                          setTemplateData={setTemplateData}
                          name={elm?.name}
                          label={elm?.label}
                          placeholder={elm?.placeHolder}
                          err={(formik as any).errors[elm.name]}
                          touched={(formik as any).touched[elm.name]}
                        />
                      </>
                    ) : elm?.name === "name" ? (
                      <LanguageInputComponentText
                        key={elm?.name}
                        label={elm?.label}
                        name={data?.name}
                        placeholder={elm?.placeHolder}
                        handlechange={(langData: any) => {
                          setNameLanguageData(langData);
                          formik.setFieldValue("name", JSON.stringify(langData));
                        }}
                      />
                    ) : (
                      <InputComponent
                        key={elm?.name}
                        id={elm?.name}
                        hint={elm?.hint}
                        handlechange={formik.handleChange}
                        accept={elm?.accept}
                        value={(formik as any)?.values?.[elm?.name]}
                        name={elm?.name}
                        label={elm?.label}
                        placeholder={elm?.placeHolder}
                        type={elm?.type}
                        error={(formik as any).errors[elm.name]}
                        touched={(formik as any).touched[elm.name]}
                      />
                    )
                  )}
                  <div className="w-full justify-between mt-4 ">
                    <label className="block mb-2 mt-3 text-xl font-bold text-darkgray font-roboto">
                      Tours
                    </label>
                    <CheckBox
                      data={Tours?.data?.data}
                      handleFilterBundleTours={handleFilterBundleTours}
                      handleAddBunleTours={handleAddBunleTours}
                      tourInBundle={tourInBundle}
                      bundleTours={bundleTours}
                      className="overflow-x-auto w-full"
                    />
                  </div>

                  {/* <div>
                  <AddStopsComponent />{" "}
                </div> */}
                </div>

                <div className="mt-9">
                  <button
                    className="w-[150px] h-[50px] border rounded border-aqua  text-aqua"
                    type="button"
                    onClick={() => {
                      formik.handleReset(formik.values);
                      setBundleTours([]);
                      setShowModal(false);
                      setTourInBundle({});
                      // setBundleTours([]);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="w-[150px] h-[50px] border rounded bg-aqua text-white ml-6"
                    type="submit"
                  >
                    Save
                  </button>
                </div>
              </form>
              {/*footer*/}
            </div>
          </div>

          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default EditBundule;
